import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Users, ArrowRight } from "lucide-react";

/**
 * EmployeeMyTeams — lists teams the current user is a member of. Each team
 * is a `guidance_requests` row with type="team" and opens straight into the
 * existing GuidanceWorkspace UI (chat / files / meetings / kanban / call).
 */
export default function EmployeeMyTeams() {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/teams/mine").then((r) => setTeams(r.data || [])).finally(() => setLoading(false));
  }, []);
  return (
    <div data-testid="employee-my-teams-page">
      <div className="kb-mono text-[10px] uppercase tracking-[0.2em] text-kb-ink-muted">EMPLOYEE · COLLABORATION</div>
      <h1 className="font-serif text-3xl lg:text-4xl text-kb-ink mt-1">My <em className="italic text-kb-primary">teams</em></h1>
      <p className="text-sm text-kb-ink-muted mt-2 max-w-2xl">Every team workspace you&apos;re part of. Open one to chat, share files, schedule meetings that sync for every member, and track team kanban.</p>

      {loading ? <div className="mt-8 kb-mono text-xs text-kb-ink-muted">Loading…</div> :
        teams.length === 0 ? (
          <div className="mt-8 text-center py-12 border border-dashed border-slate-300 rounded-sm bg-white">
            <Users className="w-8 h-8 text-kb-ink-light mx-auto" strokeWidth={1.5} />
            <p className="mt-3 text-sm text-kb-ink-muted">You&apos;re not in any team yet. An admin can add you from Admin → Team Workspaces.</p>
          </div>
        ) : (
          <div className="mt-8 space-y-3">
            {teams.map((t) => (
              <Link
                key={t.id}
                to={`/dashboard/teams/${t.id}`}
                className="kb-card p-5 flex flex-wrap items-center justify-between gap-3 hover:border-kb-primary transition-colors"
                data-testid={`my-team-${t.id}`}
              >
                <div className="flex-1 min-w-0">
                  <div className="text-base font-medium text-kb-ink">{t.team_name || "Untitled team"}</div>
                  <div className="kb-mono text-[10px] uppercase tracking-wider text-kb-ink-muted mt-1">
                    {(t.participants || []).length} member{(t.participants || []).length === 1 ? "" : "s"}
                  </div>
                  {t.problem_description && t.problem_description !== t.team_name && (
                    <div className="text-xs text-kb-ink-muted mt-1 line-clamp-2">{t.problem_description}</div>
                  )}
                </div>
                <div className="text-kb-primary inline-flex items-center gap-2 text-sm shrink-0">
                  Open workspace <ArrowRight className="w-4 h-4" />
                </div>
              </Link>
            ))}
          </div>
        )}
    </div>
  );
}
